import { declOfNum } from '../../../../../../helpers/dspx-utils';

export const getDeclRoom = (num) =>
  declOfNum(num, ['помещение', 'помещения', 'помещений']);
